export const ROUTE_PATHS = {
  //ConfigureAgreement
  Utilities_ConfigureAgreement_CommissionRemittance:
    "/utilitiestabs/configureagreement/commissionremittance",
  //JobConfiguration
  Utilities_JobConfiguration_Index: "/utilitiestabs/JobConfiguration",
  Home: "/home",
  CarrierAgreementMgmt_home: "/CarrierAgreementMgmt",
  CarrierAgreementMgmt_carriers: "/CarrierAgreementMgmt/carriers",
  Policyfee: "/policyfee",
  CarrierAgreementMgmt_office: "/officesettings",
  OfficeTab_office: "/officesettings/officesetting",
  EmployeeTab_employee: "/employeetab",
  EmployeeTab_employee_index: "/employeetab/employee",
  VendorTab_vendor: "/vendortab",
  VendorTab_vendor_index: "/vendortab/vendor",
  VendorTab_vendorinvoice_index: "/vendortab/invoice",
  ReportsTab_reports: "/reportstab",
  ReportsTab_reports_index: "/reportstab/reports",
  UtilitiesTab: "/utilitiestabs",
  Notifications: "/notifications",
  //REPORTS MODULE PATHS
  //fdfd
  CSOPC_Reports_Index: "/reportstab/producercode/csopc_reports",
  // Exception_Reports: "/reportstab/reports/exceptionreport",
  MappedToCDRC_Reports: "/reportstab/producercode/mappedtocdrc_reports",
  Snowflake_Reports: "/reportstab/producercode/tableau_reports",
  AL3_Reports: "/reportstab/producercode/al3_reports",
  MappedToKeeper_Reports: "/reportstab/producercode/keeper_reports",
  CarrierAgreement_Reports_Index: "/reportstab/carrier_agreement",
  Carrier_Reports_Index: "/reportstab/carrier",
  CarrierEAndO_Reports_Index: "/reportstab/carrier/carrier_e&o_reports",
  CarrierEAndOPerState_Reports_Index:
    "/reportstab/carrier/carrier_e&o_reports_per_state",

  // AllOpenOffices_Reports: "/reportstab/reports/allopenoffices",
  DarkOffices_Reports: "/reportstab/office/darkoffices",
  AllOfficesStatus_Reports: "/reportstab/office/allofficesstatus",
  BillsOfficeHierarchy_Reports: "/reportstab/office/billsOfficeHierarchyReport",
  OfficeHierarchy_Reports: "/reportstab/office/officeHierarchyReport",
  OfficeHours_Reports: "/reportstab/office/officeHoursReport",
  SPLCOffices_Reports: "/reportstab/office/splcOfficesReport",
  SalesforceAll_Reports: "/reportstab/office/salesforceOfficesReport",
  SalesOperations_Reports: "/reportstab/office/salesoperationsReport",
  ScorecardDaily_Reports_Index: "/reportstab/scorecard/scorecard_daily_reports",
  ScorecardClosed_Reports: "/reportstab/scorecard/scorecard_closed_reports",
  ScorecardOpen_Reports: "/reportstab/scorecard/scorecard_open_reports",
  Reports_Office_Index: "/reportstab/office",
  Reports_Scorecard_Index: "/reportstab/scorecard",
  Reports_BLP_Index: "/reportstab/business_license",
  AllOpenOffices_Reports: "/reportstab/office/allopen_offices_reports",
  DigitalAsset_Report_Index: "/reportstab/digital_assets",
  LeasedEquipment_Report_Index: "/reportstab/leased_equipment",
  Business_License_Listing_ALL_Confie:
    "/reportstab/business_license/business_licenses_permits_allconfie_report",
  Business_License_Listing_West_BU:
    "/reportstab/business_license/business_licenses_permits_westBU_report",
  //Utilities

  Utilities_Entity_Index: "/utilitiestabs/entity/index",
  Utilities_EmailRecipient_Index: "/utilitiestabs/EmailRecipientConfiguration",
  Utilities_EmailRecipientConfieguration_Index:
    "/utilitiestabs/EmailRecipientConfiguration/EmailRecipient",
  Utilities_EmailRecipientConfiegurationWorkFlow_Index:
    "/utilitiestabs/EmailRecipientConfiguration/EmailWorkFlow",
  Utilities_EmailLogs_Index:
    "/utilitiestabs/EmailRecipientConfiguration/EmailLogs",
  Utilities_LicenseType_Index: "/utilitiestabs/configureagreement/licensetype",
  Utilities_AgreementConfiguration_BusinessType:
    "/utilitiestabs/configureagreement/businesstype",
  Utilities_AgreementConfiguration_LineofBusiness:
    "/utilitiestabs/configureagreement/lineofbusiness",
  Utilities_AgreementConfiguration_Risk:
    "/utilitiestabs/configureagreement/risk",
  Utilities_AgreementConfiguration_AgencyMapping:
    "/utilitiestabs/configureagreement/agencymapping",
  Utilities_AgreementConfiguration_PaymentRemittanceType:
    "/utilitiestabs/configureagreement/paymentremittancetype",

  Utilities_AgreementConfiguration_MasterLegalEntity:
    "/utilitiestabs/configureagreement/masterlegalentity",

  //Utilities Producer Configuration
  Utilities_ProducerConfiguration_Index: "/utilitiestabs/ProducerConfiguration",
  Utilities_ProducerConfiguration_LobType:
    "/utilitiestabs/ProducerConfiguration/LobType",
  Utilities_ProducerConfiguration_CarrierProgram:
    "/utilitiestabs/ProducerConfiguration/CarrierProgram",
  Utilities_ProducerConfiguration_ProducerCodeType:
    "/utilitiestabs/ProducerConfiguration/ProducerCodeType",
  Utilities_ProducerConfiguration_MGA:
    "/utilitiestabs/ProducerConfiguration/MGA",
  Utilities_ProducerConfiguration_DistributionChannel:
    "/utilitiestabs/ProducerConfiguration/DistributionChannel",
  Utilities_ProducerConfiguration_CodeLevel:
    "/utilitiestabs/ProducerConfiguration/CodeLevel",
  //Execute query
  Utilities_ExecuteQuery_Index: "/utilitiestabs/ExecuteQuery",
  //Jobs
  Utilities_Jobs_Index: "/utilitiestabs/Jobs",
  //Utilities Employee Type
  Utilities_EmployeeType_Index: "/utilitiestabs/EmployeeConfiguration",
  Utilities_EmployeeType_EmployeeStatus_Index:
    "/utilitiestabs/EmployeeConfiguration/EmployeeStatus/index",
  Utilities_EmployeeType_EmployeeType_Index:
    "/utilitiestabs/EmployeeConfiguration/EmployeeType/index",
  Utilities_EmployeeType_EmploymentType_Index:
    "/utilitiestabs/EmployeeConfiguration/EmploymentType/index",
  Utilities_EmployeeTiTle_Index:
    "/utilitiestabs/EmployeeConfiguration/EmployeeTitle/Index",
  Utilities_EmailDomain_Index:
    "/utilitiestabs/EmployeeConfiguration/EmailDomain/Index",
  Utilities_EmployeeBilingual_Index:
    "/utilitiestabs/EmployeeConfiguration/EmployeeBilingual/index",
  Utilities_EmployeeReportsTo_Index:
    "/utilitiestabs/EmployeeConfiguration/EmployeeReportsTo/index",
  Utilities_HomeCompany_Index:
    "/utilitiestabs/EmployeeConfiguration/HomeCompanyConfig/index",
  Utilities_AdOverrideGroup_Index:
    "/utilitiestabs/EmployeeConfiguration/AdOverrideGroup/index",

  // Utilities Security Configuration
  Utilities_SecurityConfiguration_Index: "/utilitiestabs/SecurityConfiguration",
  Utilities_SecurityConfiguration_DataConnection_Index:
    "/utilitiestabs/SecurityConfiguration/DataConnection",
  Utilities_SecurityConfiguration_AlarmType_Index:
    "/utilitiestabs/SecurityConfiguration/AlarmType",
  Utilities_SecurityConfiguration_DVRType_Index:
    "/utilitiestabs/SecurityConfiguration/DVRType",
  Utilities_SecurityConfiguration_CameraSystem_Index:
    "/utilitiestabs/SecurityConfiguration/CameraSystem",
  Utilities_SecurityConfiguration_FileCategory_Index:
    "/utilitiestabs/SecurityConfiguration/FileCategory",
  Utilities_SecurityConfiguration_WarrantyCoverage_Index:
    "/utilitiestabs/SecurityConfiguration/WarrantyCoverage",
  Utilities_SecurityConfiguration_SafeType_Index:
    "/utilitiestabs/SecurityConfiguration/SafeType",
  Utilities_SecurityConfiguration_SafeMake_Index:
    "/utilitiestabs/SecurityConfiguration/SafeMake",
  Utilities_SecurityConfiguration_CameraType1_Index:
    "/utilitiestabs/SecurityConfiguration/CameraType1",
  Utilities_SecurityConfiguration_CameraType2_Index:
    "/utilitiestabs/SecurityConfiguration/CameraType2",

  //Utilities Agreement
  Utilities_configureagreement_Index: "/utilitiestabs/configureagreement",
  Utilities_configureagreement_PolicyType_Index:
    "/utilitiestabs/configureagreement/policytype",
  Utilities_configureagreement_SalesLead_Index:
    "/utilitiestabs/configureagreement/saleslead",
  Utilities_configureagreement_Standard_Index:
    "/utilitiestabs/configureagreement/standard",

  //Utilities Leased Equipment
  Utilities_LeasedEquipmentConfiguration_Index:
    "/utilitiestabs/LeasedEquipmentConfiguration",
  Utilities_LeasedEquipmentConfiguration_Status_Index:
    "/utilitiestabs/LeasedEquipmentConfiguration/Status",
  Utilities_LeasedEquipmentConfiguration_Type_Index:
    "/utilitiestabs/LeasedEquipmentConfiguration/Type",
  Utilities_LeasedEquipmentConfiguration_Make_Index:
    "/utilitiestabs/LeasedEquipmentConfiguration/Make",
  Utilities_LeasedEquipmentConfiguration_Model_Index:
    "/utilitiestabs/LeasedEquipmentConfiguration/Model",
  Utilities_LeasedEquipmentConfiguration_SupplyAlertProfile_Index:
    "/utilitiestabs/LeasedEquipmentConfiguration/SupplyAlertProfile",

  //Utilities Policy Term
  Utilities_PolicyTerm_Index: "/utilitiestabs/PolicyTerm",
  Utilities_PolicyTerm_FeeLevel_Index: "/utilitiestabs/PolicyTerm/feeLevel",
  Utilities_PolicyTerm_FeeType_Index: "/utilitiestabs/PolicyTerm/feeType",
  Utilities_PolicyTerm_Terms_Index: "/utilitiestabs/PolicyTerm/terms",
  //Utilities Office
  Utilities_Office_Index: "/utilitiestabs/Office",
  Utilities_Office_GLEntity_Index: "/utilitiestabs/Office/GLEntity",
  Utilities_Office_OfficeDivision_Index:
    "/utilitiestabs/Office/OfficeDivision/Index",
  Utilities_Office_OfficeBrand_Index: "/utilitiestabs/Office/OfficeBrand",
  Utilities_Office_OfficeStatus_Index:
    "/utilitiestabs/Office/OfficeStatus/Index",
  Utilities_BusinessOperation_Index: "/utilitiestabs/Office/BusinessOperation",
  Utilities_Office_Channel_Index: "/utilitiestabs/Office/Channel/Index",
  Utilities_Office_OfficeType_Index: "/utilitiestabs/Office/OfficeType",
  Utilities_Office_OfficeOrigin_Index:
    "/utilitiestabs/Office/OfficeOrigin/Index",
  Utilities_Office_StatusDetails_Index:
    "/utilitiestabs/Office/OfficeStatusDetails/Index",
  Utilities_Office_TexasGroupings_Index:
    "/utilitiestabs/Office/TexasGrouping/index",
  Utilities_Office_TargetSystem_Index:
    "/utilitiestabs/Office/PolicyManagementSystem/Index",
  Utilities_Office_OfficeDepartment_Index:
    "/utilitiestabs/Office/OfficeDepartment/Index",
  Utilities_Office_BMO: "/utilitiestabs/Office/BMO",
  Utilities_Office_OfficeBank: "/utilitiestabs/Office/OfficeBank",

  Utilities_Office_OfficeAccount_Index: "/utilitiestabs/Office/OfficeAccount",
  //Utilities Office Hierarchy
  Utilities_OfficeHierarchy_Index:
    "/utilitiestabs/OfficeHierarchyConfiguration/index",
  Utilities_OfficeHierarchy_District_Index:
    "/utilitiestabs/OfficeHierarchyConfiguration/District/index",
  Utilities_OfficeHierarchy_Region_Index:
    "/utilitiestabs/OfficeHierarchyConfiguration/Region/index",
  Utilities_OfficeHierarchy_Territory_Index:
    "/utilitiestabs/OfficeHierarchyConfiguration/Territory/index",
  Utilities_OfficeHierarchy_Area_Index:
    "/utilitiestabs/OfficeHierarchyConfiguration/Area/index",

  //Utilities Operations Group
  Utilities_OperationsGroup_Index:
    "/utilitiestabs/OperationsGroupConfiguration/index",

  //Utilities User Management
  Utilities_UserRoleManagement_Index:
    "/utilitiestabs/UserModuleandRoleMgt/index",
  Utilities_UserManagement_Index: "/utilitiestabs/UsersManagement/index",
  Utilities_RoleSetting_Index: "/utilitiestabs/RoleSetting/index",

  //Utilities BLP Type
  Utilities_BusinessLicensesPermits_Type_Index:
    "/utilitiestabs/BusinessLicensesPermitsConfiguration",
  //Utilities Digital Assets Online Directories
  Utilities_DigitalAssets_OnlineDirectories_Index:
    "/utilitiestabs/DigitalAssetsConfiguration/OnlineDirectories/index",

  //Ssales Type
  Utilities_Office_SalesType_Index: "/utilitiestabs/Office/SalesType/Index",

  //
  Utilities_ScriptConfiguration_Index:
    "/utilitiestabs/ScriptConfiguration/Index",

  Utilities_VendorConfiguration_Index:
    "/utilitiestabs/VendorConfiguration/Index",
  Utilities_VendorConfiguration_ExpenseAccount_Index:
    "/utilitiestabs/VendorConfiguration/ExpenseAccount",
  Utilities_VendorConfiguration_Autopay_Index:
    "/utilitiestabs/VendorConfiguration/Autopay",

  //Utilities Acquisition Configuration
  Utilities_AcquisitionConfiguration_Index:
    "/utilitiestabs/Office/AcquisitionConfiguration/Index",

  Utilities_OfficeAppliancesConfiguration_Index:
    "/utilitiestabs/AppliancesConfiguration",
  Utilities_OfficeAppliancesConfiguration_Type_Index:
    "/utilitiestabs/AppliancesConfiguration/Type",

  Utilities_OfficeAppliances_Brand_Index:
    "/utilitiestabs/AppliancesConfiguration/Brand",
};

export const PERMISSIONS = {
  //Execute Query
  permission_executequery_view: "permission.executequery.view",
  permission_dashboard_view: "permission.dashboard.view",
  //CarrierAgreementMgmt
  permission_carrieragreemnentmgmt_view:
    "permission.carrieragreemnentmgmt.view",
  //CarrierAgreementMgmt Carrier
  permission_carrieragreemnentmgmt_carrier_view:
    "permission.carrieragreemnentmgmt.carrier.view",
  permission_carrieragreemnentmgmt_carrier_add:
    "permission.carrieragreemnentmgmt.carrier.add",
  permission_carrieragreemnentmgmt_carrier_edit:
    "permission.carrieragreemnentmgmt.carrier.edit",
  // permission_carrieragreemnentmgmt_carrier_delete:
  //   "permission.carrieragreemnentmgmt.carrier.delete",
  permission_carrieragreemnentmgmt_carrier_download:
    "permission.carrieragreemnentmgmt.carrier.download",
  permission_carrieragreemnentmgmt_carrier_massupload:
    "permission.carrieragreemnentmgmt.carrier.massupload",
  //CarrierAgreementMgmt Agreement
  permission_carrieragreemnentmgmt_agreement_view:
    "permission.carrieragreemnentmgmt.agreement.view",
  permission_carrieragreemnentmgmt_agreement_add:
    "permission.carrieragreemnentmgmt.agreement.add",
  permission_carrieragreemnentmgmt_agreement_edit:
    "permission.carrieragreemnentmgmt.agreement.edit",
  // permission_carrieragreemnentmgmt_agreement_delete:
  //   "permission.carrieragreemnentmgmt.agreement.delete",
  permission_carrieragreemnentmgmt_agreement_download:
    "permission.carrieragreemnentmgmt.agreement.download",
  permission_carrieragreemnentmgmt_agreement_massupload:
    "permission.carrieragreemnentmgmt.agreement.massupload",
  permission_agmtField_comValStatus: "permission.agmtfield.comvalstatus",

  //Office Appliance
  permission_officeappliance_view: "permission.officeappliance.view",
  permission_officeappliance_add: "permission.officeappliance.add",
  permission_officeappliance_edit: "permission.officeappliance.edit",
  permission_officeappliance_delete: "permission.officeappliance.delete",

  //US Employee
  permission_carrieragreemnentmgmt_employee_view:
    "permission.employee.confie.view",
  permission_carrieragreemnentmgmt_employee_add:
    "permission.employee.confie.add",
  permission_carrieragreemnentmgmt_employee_edit:
    "permission.employee.confie.edit",
  permission_carrieragreemnentmgmt_employee_delete:
    "permission.employee.confie.delete",
  permission_carrieragreemnentmgmt_employee_download:
    "permission.carrieragreemnentmgmt.employee.download",

  //MX Employee
  permission_employee_mexicoemployee_view:
    "permission.employee.mexicoemployee.view",
  permission_employee_mexicoemployee_add:
    "permission.employee.mexicoemployee.add",
  permission_employee_mexicoemployee_edit:
    "permission.employee.mexicoemployee.edit",
  permission_employee_mexicoemployee_delete:
    "permission.employee.mexicoemployee.delete",

  //Franchise Employee
  permission_employee_franchise_view: "permission.employee.franchise.view",
  permission_employee_franchise_add: "permission.employee.franchise.add",
  permission_employee_franchise_edit: "permission.employee.franchise.edit",

  //Main Employee View
  permission_employee_main_view: "permission.employee.main.view",
  //CarrierAgreementMgmt DigitalAsset
  permission_carrieragreemnentmgmt_digitalassets_view:
    "permission.carrieragreemnentmgmt.digitalassets.view",
  permission_carrieragreemnentmgmt_digitalassets_add:
    "permission.carrieragreemnentmgmt.digitalassets.add",
  permission_carrieragreemnentmgmt_digitalassets_edit:
    "permission.carrieragreemnentmgmt.digitalassets.edit",
  permission_carrieragreemnentmgmt_digitalassets_delete:
    "permission.carrieragreemnentmgmt.digitalassets.delete",
  permission_carrieragreemnentmgmt_digitalassets_download:
    "permission.carrieragreemnentmgmt.digitalassets.download",
  //CarrierAgreementMgmt OfficeHierarchy
  permission_carrieragreemnentmgmt_officehierarchy_view:
    "permission.carrieragreemnentmgmt.officehierarchy.view",
  permission_carrieragreemnentmgmt_officehierarchy_add:
    "permission.carrieragreemnentmgmt.officehierarchy.add",
  permission_carrieragreemnentmgmt_officehierarchy_edit:
    "permission.carrieragreemnentmgmt.officehierarchy.edit",
  permission_carrieragreemnentmgmt_officehierarchy_delete:
    "permission.carrieragreemnentmgmt.officehierarchy.delete",
  permission_carrieragreemnentmgmt_officehierarchy_download:
    "permission.carrieragreemnentmgmt.officehierarchy.download",

  //Agreement Report
  permission_carrieragreemnentmgmt_report_view:
    "permission.report.agreement.view",

  //Producer Code Report
  permission_report_producercode_view: "permission.report.producer.view",
  permission_report_carrierstatesofficecode_view:
    "permission.report.carrierstatesofficecode.view",
  permission_report_cdrcexception_view: "permission.report.cdrcexception.view",
  permission_report_allsnowflakes_view:
    "permission.report.carrierproducercodes.allsnowflakes.view",
  permission_report_allal3_view:
    "permission.report.carrierproducercodes.allal3.view",
  permission_report_keeperexception_view:
    "permission.report.carrierproducercodes.keeperexception.view",

  permission_carrieragreemnentmgmt_report_office_darkreports:
    "permission_carrieragreemnentmgmt_report_office_darkreports",

  permission_report_digitalasset_digitalassetsreport_view:
    "permission.report.digitalasset.digitalassetsreport.view",

  //Carrier
  permission_report_carrier_view: "permission.report.carrier.view",
  permission_report_carrier_eandocontact_view:
    "permission.report.carrier.e&ocontact.view",
  permission_report_carrier_eandocontactperstate_view:
    "permission.report.carrier.e&ocontactperstate.view",

  //CarrierAgreementMgmt Report Scorecards
  permission_report_scorecard__view:
    "permission.report.scorecard.scorecardreports.view",
  permission_report_scorecard_scorecardreportsdaily_view:
    "permission.report.scorecard.scorecardreportsdaily.view",
  permission_report_scorecard_scorecardreportsclosed_view:
    "permission.report.scorecard.scorecardreportsclosed.view",
  permission_report_scorecard_scorecardreportsopen_view:
    "permission.report.scorecard.scorecardreportsopen.view",

  //CarrierAgreementMgmt Report Offices
  permission_report_office_view: "permission.report.office.view",
  permission_report_office_allopenoffice_view:
    "permission.report.office.allopenoffice.view",
  permission_report_office_darkreports_view:
    "permission.report.office.darkreports.view",
  permission_report_office_allstatusoffice_view:
    "permission.report.office.allstatusoffice.view",
  permission_report_office_officehours_view:
    "permission.report.office.officehours.view",
  permission_report_office_officehierarchy_view:
    "permission.report.office.officehierarchy.view",
  permission_report_office_billsofficehierarchy_view:
    "permission.report.office.billsofficehierarchy.view",
  permission_report_office_splcoffices_view:
    "permission.report.office.splcoffices.view",
  permission_report_office_salesoperations_view:
    "permission.report.office.salesoperations.view",
  permission_report_office_salesforceall_view:
    "permission.report.office.salesforceall.view",

  //CarrierAgreementMgmt ProdCode
  permission_carrieragreemnentmgmt_producercode_view:
    "permission.carrieragreemnentmgmt.producercode.view",
  permission_carrieragreemnentmgmt_producercode_add:
    "permission.carrieragreemnentmgmt.producercode.add",
  permission_carrieragreemnentmgmt_producercode_edit:
    "permission.carrieragreemnentmgmt.producercode.edit",
  permission_carrieragreemnentmgmt_producercode_delete:
    "permission.carrieragreemnentmgmt.producercode.delete",
  permission_carrieragreemnentmgmt_producercode_massupload:
    "permission.carrieragreemnentmgmt.producercode.massupload",
  permission_carrieragreemnentmgmt_producercode_download:
    "permission.carrieragreemnentmgmt.producercode.download",
  //PolicyFee
  permission_policyfee_view: "permission.policyfee.view",
  permission_policyfee_add: "permission.policyfee.add",
  permission_policyfee_edit: "permission.policyfee.edit",
  // permission_policyfee_delete: "permission.policyfee.delete",
  permission_policyfee_download: "permission.policyfee.download",
  //Utilities
  permission_utilities_view: "permission.utilities.view",
  //Producer Configuration Utility
  permission_utilities_producerconfiguration_view:
    "permission.utilities.producerconfiguration.view",
  permission_utilities_lobtype_view: "permission.utilities.lobtype.view",
  permission_utilities_lobtype_add: "permission.utilities.lobtype.add",
  permission_utilities_lobtype_edit: "permission.utilities.lobtype.edit",
  permission_utilities_lobtype_delete: "permission.utilities.lobtype.delete",
  // Carrier Program
  permission_utilities_carrierprogram_view:
    "permission.utilities.carrierprogram.view",
  permission_utilities_carrierprogram_add:
    "permission.utilities.carrierprogram.add",
  permission_utilities_carrierprogram_edit:
    "permission.utilities.carrierprogram.edit",
  permission_utilities_carrierprogram_delete:
    "permission.utilities.carrierprogram.delete",
  // MGA
  permission_utilities_mga_view: "permission.utilities.mga.view",
  permission_utilities_mga_add: "permission.utilities.mga.add",
  permission_utilities_mga_edit: "permission.utilities.mga.edit",
  permission_utilities_mga_delete: "permission.utilities.mga.delete",
  // Distribution Channel
  permission_utilities_distributionchannel_view:
    "permission.utilities.distributionchannel.view",
  permission_utilities_distributionchannel_add:
    "permission.utilities.distributionchannel.add",
  permission_utilities_distributionchannel_edit:
    "permission.utilities.distributionchannel.edit",
  permission_utilities_distributionchannel_delete:
    "permission.utilities.distributionchannel.delete",
  // Code Level
  permission_utilities_codelevel_view: "permission.utilities.codelevel.view",
  permission_utilities_codelevel_add: "permission.utilities.codelevel.add",
  permission_utilities_codelevel_edit: "permission.utilities.codelevel.edit",
  permission_utilities_codelevel_delete:
    "permission.utilities.codelevel.delete",
  // Producer Code Type
  permission_utilities_producercodetype_view:
    "permission.utilities.producercodetype.view",
  permission_utilities_producercodetype_add:
    "permission.utilities.producercodetype.add",
  permission_utilities_producercodetype_edit:
    "permission.utilities.producercodetype.edit",
  permission_utilities_producercodetype_delete:
    "permission.utilities.producercodetype.delete",

  //LeasedEquipmentConfiguration Utility
  permission_utilities_leasedconfiguration_view:
    "permission.utilities.leasedequipmentconfiguration.view",

  //LeasedEquipment Status Utility
  permission_utilities_leasedequipment_status_view:
    "permission.utilities.leasedequipmentconfiguration.status.view",
  permission_utilities_leasedequipment_status_add:
    "permission.utilities.leasedequipmentconfiguration.status.add",
  permission_utilities_leasedequipment_status_edit:
    "permission.utilities.leasedequipmentconfiguration.status.edit",
  permission_utilities_leasedequipment_status_delete:
    "permission.utilities.leasedequipmentconfiguration.status.delete",

  //LeasedEquipment Type Utility
  permission_utilities_leasedequipment_type_view:
    "permission.utilities.leasedequipmentconfiguration.type.view",
  permission_utilities_leasedequipment_type_add:
    "permission.utilities.leasedequipmentconfiguration.type.add",
  permission_utilities_leasedequipment_type_edit:
    "permission.utilities.leasedequipmentconfiguration.type.edit",
  permission_utilities_leasedequipment_type_delete:
    "permission.utilities.leasedequipmentconfiguration.type.delete",

  //LeasedEquipment Make Utility
  permission_utilities_leasedequipment_make_view:
    "permission.utilities.leasedequipmentconfiguration.make.view",
  permission_utilities_leasedequipment_make_add:
    "permission.utilities.leasedequipmentconfiguration.make.add",
  permission_utilities_leasedequipment_make_edit:
    "permission.utilities.leasedequipmentconfiguration.make.edit",
  permission_utilities_leasedequipment_make_delete:
    "permission.utilities.leasedequipmentconfiguration.make.delete",

  //LeasedEquipment Model Utility
  permission_utilities_leasedequipment_model_view:
    "permission.utilities.leasedequipmentconfiguration.model.view",
  permission_utilities_leasedequipment_model_add:
    "permission.utilities.leasedequipmentconfiguration.model.add",
  permission_utilities_leasedequipment_model_edit:
    "permission.utilities.leasedequipmentconfiguration.model.edit",
  permission_utilities_leasedequipment_model_delete:
    "permission.utilities.leasedequipmentconfiguration.model.delete",

  //LeasedEquipment SupplyAlertProfile Utilitiy
  permission_utilities_leasedequipment_supplyalertprofile_view:
    "permission.utilities.leasedequipmentconfiguration.supplyalertprofile.view",
  permission_utilities_leasedequipment_supplyalertprofile_add:
    "permission.utilities.leasedequipmentconfiguration.supplyalertprofile.add",
  permission_utilities_leasedequipment_supplyalertprofile_edit:
    "permission.utilities.leasedequipmentconfiguration.supplyalertprofile.edit",
  permission_utilities_leasedequipment_supplyalertprofile_delete:
    "permission.utilities.leasedequipmentconfiguration.supplyalertprofile.delete",

  //Entity Utility
  permission_utilities_entity_view: "permission.utilities.entity.view",
  permission_utilities_entity_add: "permission.utilities.entity.add",
  permission_utilities_entity_edit: "permission.utilities.entity.edit",
  permission_utilities_entity_delete: "permission.utilities.entity.delete",
  permission_utilities_entity_massupload:
    "permission.utilities.entity.massupload",
  permission_utilities_entity_download: "permission.utilities.entity.download",
  //GLEntity Utility
  permission_utilities_glentity_view: "permission.utilities.glentity.view",
  permission_utilities_glentity_add: "permission.utilities.glentity.add",
  permission_utilities_glentity_edit: "permission.utilities.glentity.edit",
  permission_utilities_glentity_delete: "permission.utilities.glentity.delete",
  //OfficeDivision Utility
  permission_utilities_officedivision_view:
    "permission.utilities.officedivision.view",
  permission_utilities_officedivision_add:
    "permission.utilities.officedivision.add",
  permission_utilities_officedivision_edit:
    "permission.utilities.officedivision.edit",
  permission_utilities_officedivision_delete:
    "permission.utilities.officedivision.delete",
  //BusinessOperation Utility
  permission_utilities_businessoperation_view:
    "permission.utilities.businessoperation.view",
  permission_utilities_businessoperation_add:
    "permission.utilities.businessoperation.add",
  permission_utilities_businessoperation_edit:
    "permission.utilities.businessoperation.edit",
  permission_utilities_businessoperation_delete:
    "permission.utilities.businessoperation.delete",
  // permission_utilities_glentity_massupload:
  //   "permission.utilities.entity.massupload",
  // permission_utilities_glentity_download:
  //   "permission.utilities.glentity.download",

  //Email Recipient Config
  permission_utilities_emailrecipientconfiguration_view:
    "permission.utilities.emailrecipientconfiguration.view",

  //Email Recipient Utility
  permission_utilities_emailrecipient_view:
    "permission.utilities.emailrecipient.view",
  permission_utilities_emailrecipient_add:
    "permission.utilities.emailrecipient.add",
  permission_utilities_emailrecipient_edit:
    "permission.utilities.emailrecipient.edit",
  permission_utilities_emailrecipient_delete:
    "permission.utilities.emailrecipient.delete",
  //Email Recipient Utility
  permission_utilities_emailworkflow_view:
    "permission.utilities.emailworkflow.view",
  permission_utilities_emailworkflow_add:
    "permission.utilities.emailworkflow.add",
  permission_utilities_emailworkflow_edit:
    "permission.utilities.emailworkflow.edit",
  permission_utilities_emailworkflow_delete:
    "permission.utilities.emailworkflow.delete",
  //Email Recipient Utility
  permission_utilities_emaillogs_view: "permission.utilities.emaillogs.view",
  permission_utilities_emaillogs_edit: "permission.utilities.emaillogs.edit",

  //License Type Utility
  permission_utilities_licensetype_view:
    "permission.utilities.licensetype.view",
  permission_utilities_licensetype_edit:
    "permission.utilities.licensetype.edit",
  permission_utilities_licensetype_add: "permission.utilities.licensetype.add",
  permission_utilities_licensetype_delete:
    "permission.utilities.licensetype.delete",
  //EmployeeType Config Utility View
  permission_utilities_employeetype_view:
    "permission.utilities.employeetype.view",
  permission_utilities_employeetype_employeestatus_view:
    "permission.utilities.employeetype.employeestatus.view",
  permission_utilities_employeetype_employeetype_view:
    "permission.utilities.employeetype.employeetype.view",
  permission_utilities_employeetype_employmenttype_view:
    "permission.utilities.employeetype.employmenttype.view",
  permission_utilities_employeetype_employeetitle_view:
    "permission.utilities.employeetype.employeetitle.view",
  permission_utilites_employeeReportsTo_view:
    "permission.utilities.employeereportsto.view",
  //EmployeeType Config Utility Add
  permission_utilities_employeetype_add:
    "permission.utilities.employeetype.add",
  permission_utilities_employeetype_employeestatus_add:
    "permission.utilities.employeetype.employeestatus.add",
  permission_utilities_employeetype_employeetype_add:
    "permission.utilities.employeetype.employeetype.add",
  permission_utilities_employeetype_employmenttype_add:
    "permission.utilities.employeetype.employmenttype.add",
  permission_utilities_employeetype_employeetitle_add:
    "permission.utilities.employeetype.employeetitle.add",
  permission_utilites_employeeReportsTo_add:
    "permission.utilities.employeereportsto.add",
  //EmployeeType Config Utility Edit
  permission_utilities_employeetype_edit:
    "permission.utilities.employeetype.edit",
  permission_utilities_employeetype_employeestatus_edit:
    "permission.utilities.employeetype.employeestatus.edit",
  permission_utilities_employeetype_employeetype_edit:
    "permission.utilities.employeetype.employeetype.edit",
  permission_utilities_employeetype_employmenttype_edit:
    "permission.utilities.employeetype.employmenttype.edit",
  permission_utilities_employeetype_employeetitle_edit:
    "permission.utilities.employeetype.employeetitle.edit",
  permission_utilites_employeeReportsTo_edit:
    "permission.utilities.employeereportsto.edit",
  //EmployeeType Config Utility Delete
  permission_utilities_employeetype_delete:
    "permission.utilities.employeetype.delete",
  permission_utilities_employeetype_employeestatus_delete:
    "permission.utilities.employeetype.employeestatus.delete",
  permission_utilities_employeetype_employeetype_delete:
    "permission.utilities.employeetype.employeetype.delete",
  permission_utilities_employeetype_employmenttype_delete:
    "permission.utilities.employeetype.employmenttype.delete",
  permission_utilities_employeetype_employeetitle_delete:
    "permission.utilities.employeetype.employeetitle.delete",
  permission_utilites_employeeReportsTo_delete:
    "permission.utilities.employeereportsto.delete",

  //Email Domain Utility
  permission_utilities_emaildomain_view:
    "permission.utilities.emaildomain.view",
  permission_utilities_emaildomain_add: "permission.utilities.emaildomain.add",
  permission_utilities_emaildomain_edit:
    "permission.utilities.emaildomain.edit",
  permission_utilities_emaildomain_delete:
    "permission.utilities.emaildomain.delete",

  //Agreement Config Utility View
  permission_utilities_configureagreement_view:
    "permission.utilities.configureagreement.view",
  permission_utilities_configureagreement_policytype_view:
    "permission.utilities.configureagreement.policytype.view",
  permission_utilities_configureagreement_saleslead_view:
    "permission.utilities.configureagreement.saleslead.view",
  permission_utilities_configureagreement_standard_view:
    "permission.utilities.configureagreement.standard.view",
  permission_utilities_configureagreement_targetsystem_view:
    "permission.utilities.configureagreement.targetsystem.view",
  permission_utilities_configureagreement_businesstype_view:
    "permission.utilities.configureagreement.businesstype.view",
  permission_utilities_configureagreement_lineofbusiness_view:
    "permission.utilities.configureagreement.lineofbusiness.view",
  permission_utilities_configureagreement_risk_view:
    "permission.utilities.configureagreement.risk.view",
  permission_utilities_configureagreement_agencymapping_view:
    "permission.utilities.configureagreement.agencymapping.view",
  permission_utilities_configureagreement_paymentremittancetype_view:
    "permission.utilities.configureagreement.paymentremittancetype.view",
  permission_utilities_configureagreement_masterlegalentity_view:
    "permission.utilities.agreementconfiguration.masterlegalentity.view",

  //Agreement Config Utility Add
  permission_utilities_configureagreement_add:
    "permission.utilities.configureagreement.add",
  permission_utilities_configureagreement_policytype_add:
    "permission.utilities.configureagreement.policytype.add",
  permission_utilities_configureagreement_saleslead_add:
    "permission.utilities.configureagreement.saleslead.add",
  permission_utilities_configureagreement_standard_add:
    "permission.utilities.configureagreement.standard.add",
  permission_utilities_configureagreement_targetsystem_add:
    "permission.utilities.configureagreement.targetsystem.add",
  permission_utilities_configureagreement_businesstype_add:
    "permission.utilities.configureagreement.businesstype.add",
  permission_utilities_configureagreement_lineofbusiness_add:
    "permission.utilities.configureagreement.lineofbusiness.add",
  permission_utilities_configureagreement_risk_add:
    "permission.utilities.configureagreement.risk.add",
  permission_utilities_configureagreement_agencymapping_add:
    "permission.utilities.configureagreement.agencymapping.add",
  permission_utilities_configureagreement_paymentremittancetype_add:
    "permission.utilities.configureagreement.paymentremittancetype.add",
  permission_utilities_configureagreement_masterlegalentity_add:
    "permission.utilities.agreementconfiguration.masterlegalentity.add",

  //Agreement Config Utility Edit
  permission_utilities_configureagreement_edit:
    "permission.utilities.configureagreement.edit",
  permission_utilities_configureagreement_policytype_edit:
    "permission.utilities.configureagreement.policytype.edit",
  permission_utilities_configureagreement_saleslead_edit:
    "permission.utilities.configureagreement.saleslead.edit",
  permission_utilities_configureagreement_standard_edit:
    "permission.utilities.configureagreement.standard.edit",
  permission_utilities_configureagreement_targetsystem_edit:
    "permission.utilities.configureagreement.targetsystem.edit",
  permission_utilities_configureagreement_businesstype_edit:
    "permission.utilities.configureagreement.businesstype.edit",
  permission_utilities_configureagreement_lineofbusiness_edit:
    "permission.utilities.configureagreement.lineofbusiness.edit",
  permission_utilities_configureagreement_risk_edit:
    "permission.utilities.configureagreement.risk.edit",
  permission_utilities_configureagreement_agencymapping_edit:
    "permission.utilities.configureagreement.agencymapping.edit",
  permission_utilities_configureagreement_paymentremittancetype_edit:
    "permission.utilities.configureagreement.paymentremittancetype.edit",
  permission_utilities_configureagreement_masterlegalentity_edit:
    "permission.utilities.agreementconfiguration.masterlegalentity.edit",

  //Agreement Config Utility Delete
  permission_utilities_configureagreement_delete:
    "permission.utilities.configureagreement.delete",
  permission_utilities_configureagreement_policytype_delete:
    "permission.utilities.configureagreement.policytype.delete",
  permission_utilities_configureagreement_saleslead_delete:
    "permission.utilities.configureagreement.saleslead.delete",
  permission_utilities_configureagreement_standard_delete:
    "permission.utilities.configureagreement.standard.delete",
  permission_utilities_configureagreement_targetsystem_delete:
    "permission.utilities.configureagreement.targetsystem.delete",
  permission_utilities_configureagreement_businesstype_delete:
    "permission.utilities.configureagreement.businesstype.delete",
  permission_utilities_configureagreement_lineofbusiness_delete:
    "permission.utilities.configureagreement.lineofbusiness.delete",
  permission_utilities_configureagreement_risk_delete:
    "permission.utilities.configureagreement.risk.delete",
  permission_utilities_configureagreement_agencymapping_delete:
    "permission.utilities.configureagreement.agencymapping.delete",
  permission_utilities_configureagreement_paymentremittancetype_delete:
    "permission.utilities.configureagreement.paymentremittancetype.delete",
  permission_utilities_configureagreement_masterlegalentity_delete:
    "permission.utilities.agreementconfiguration.masterlegalentity.delete",

  //Policy Term Config Utility View
  permission_utilities_policyterm_view: "permission.utilities.policyterm.view",
  permission_utilities_policyterm_feelevel_view:
    "permission.utilities.policyterm.feelevel.view",
  permission_utilities_policyterm_feetype_view:
    "permission.utilities.policyterm.feetype.view",
  permission_utilities_policyterm_terms_view:
    "permission.utilities.policyterm.terms.view",
  //Policy Term Config Utility Edit
  permission_utilities_policyterm_edit: "permission.utilities.policyterm.edit",
  permission_utilities_policyterm_feelevel_edit:
    "permission.utilities.policyterm.feelevel.edit",
  permission_utilities_policyterm_feetype_edit:
    "permission.utilities.policyterm.feetype.edit",
  permission_utilities_policyterm_terms_edit:
    "permission.utilities.policyterm.terms.edit",
  //Policy Term Config Utility Add
  permission_utilities_policyterm_add: "permission.utilities.policyterm.add",
  permission_utilities_policyterm_feelevel_add:
    "permission.utilities.policyterm.feelevel.add",
  permission_utilities_policyterm_feetype_add:
    "permission.utilities.policyterm.feetype.add",
  permission_utilities_policyterm_terms_add:
    "permission.utilities.policyterm.terms.add",
  //Policy Term Config Utility Delete
  permission_utilities_policyterm_delete:
    "permission.utilities.policyterm.delete",
  permission_utilities_policyterm_feelevel_delete:
    "permission.utilities.policyterm.feelevel.delete",
  permission_utilities_policyterm_feetype_delete:
    "permission.utilities.policyterm.feetype.delete",
  permission_utilities_policyterm_terms_delete:
    "permission.utilities.policyterm.terms.delete",
  //Office Hierarchy Utility View
  permission_utilities_officehierarchyconfiguration_view:
    "permission.utilities.officehierarchyconfiguration.view",
  //Office Hierarchy Utility District View
  permission_utilities_officehierarchyconfiguration_district_view:
    "permission.utilities.officehierarchyconfiguration.district.view",
  //Office Hierarchy Utilityy District Add
  permission_utilities_officehierarchyconfiguration_district_add:
    "permission.utilities.officehierarchyconfiguration.district.add",
  //Office Hierarchy Utilityy District Edit
  permission_utilities_officehierarchyconfiguration_district_edit:
    "permission.utilities.officehierarchyconfiguration.district.edit",
  //Office Hierarchy Utilityy District Delete
  permission_utilities_officehierarchyconfiguration_district_delete:
    "permission.utilities.officehierarchyconfiguration.district.delete",
  //End of District

  //Territory
  permission_utilities_officehierarchyconfiguration_territory_view:
    "permission.utilities.officehierarchyconfiguration.territory.view",
  //Office Hierarchy Utility Add
  permission_utilities_officehierarchyconfiguration_territory_add:
    "permission.utilities.officehierarchyconfiguration.territory.add",
  //Office Hierarchy Utility Edit
  permission_utilities_officehierarchyconfiguration_territory_edit:
    "permission.utilities.officehierarchyconfiguration.territory.edit",

  //Office Hierarchy Utility Delete
  permission_utilities_officehierarchyconfiguration_territory_delete:
    "permission.utilities.officehierarchyconfiguration.territory.delete",
  //End of Territory

  //Office Hierarchy Utility Region View
  permission_utilities_officehierarchyconfiguration_region_view:
    "permission.utilities.officehierarchyconfiguration.region.view",
  //Office Hierarchy Utilityy Region Add
  permission_utilities_officehierarchyconfiguration_region_add:
    "permission.utilities.officehierarchyconfiguration.region.add",
  //Office Hierarchy Utilityy Region Edit
  permission_utilities_officehierarchyconfiguration_region_edit:
    "permission.utilities.officehierarchyconfiguration.region.edit",
  //Office Hierarchy Utilityy Region Delete
  permission_utilities_officehierarchyconfiguration_region_delete:
    "permission.utilities.officehierarchyconfiguration.region.delete",
  //Office Hierarchy Utility Area View
  permission_utilities_officehierarchyconfiguration_area_view:
    "permission.utilities.officehierarchyconfiguration.area.view",
  //Office Hierarchy Utilityy Area Add
  permission_utilities_officehierarchyconfiguration_area_add:
    "permission.utilities.officehierarchyconfiguration.area.add",
  //Office Hierarchy Utilityy Area Edit
  permission_utilities_officehierarchyconfiguration_area_edit:
    "permission.utilities.officehierarchyconfiguration.area.edit",
  //Office Hierarchy Utilityy Area Delete
  permission_utilities_officehierarchyconfiguration_area_delete:
    "permission.utilities.officehierarchyconfiguration.area.delete",
  //Office Config Utility View
  permission_utilities_officeconfiguration_view:
    "permission.utilities.officeconfiguration.view",
  permission_utilities_officeconfiguration_glentity_view:
    "permission.utilities.officeconfiguration.glentity.view",
  permission_utilities_officeconfiguration_officebrand_view:
    "permission.utilities.officeconfiguration.officebrand.view",
  permission_utilities_officeconfiguration_officestatus_view:
    "permission.utilities.officeconfiguration.officestatus.view",
  permission_utilities_officeconfiguration_officetype_view:
    "permission.utilities.officeconfiguration.officetype.view",
  permission_utilities_officeconfiguration_channel_view:
    "permission.utilities.officeconfiguration.channel.view",
  permission_utilities_officeconfiguration_salestype_view:
    "permission.utilities.officeconfiguration.salestype.view",
  permission_utilities_officeconfiguration_officeorigin_view:
    "permission.utilities.officeconfiguration.officeorigin.view",
  permission_utilities_officeconfiguration_officestatusdetails_view:
    "permission.utilities.officeconfiguration.officestatusdetails.view",
  //Office Config Utility Edit
  permission_utilities_officeconfiguration_edit:
    "permission.utilities.officeconfiguration.edit",
  permission_utilities_officeconfiguration_glentity_edit:
    "permission.utilities.officeconfiguration.glentity.edit",
  permission_utilities_officeconfiguration_officebrand_edit:
    "permission.utilities.officeconfiguration.officebrand.edit",
  permission_utilities_officeconfiguration_officestatus_edit:
    "permission.utilities.officeconfiguration.officestatus.edit",
  permission_utilities_officeconfiguration_officetype_edit:
    "permission.utilities.officeconfiguration.officetype.edit",
  permission_utilities_officeconfiguration_channel_edit:
    "permission.utilities.officeconfiguration.channel.edit",
  permission_utilities_officeconfiguration_salestype_edit:
    "permission.utilities.officeconfiguration.salestype.edit",
  permission_utilities_officeconfiguration_officeorigin_edit:
    "permission.utilities.officeconfiguration.officeorigin.edit",
  permission_utilities_officeconfiguration_officestatusdetails_edit:
    "permission.utilities.officeconfiguration.officestatusdetails.edit",
  permission_utilities_officeconfiguration_officedivision_edit:
    "permission.utilities.officedivision.edit",
  //Office Config Utility Add
  permission_utilities_officeconfiguration_add:
    "permission.utilities.officeconfiguration.add",
  permission_utilities_officeconfiguration_glentity_add:
    "permission.utilities.officeconfiguration.glentity.add",
  permission_utilities_officeconfiguration_officebrand_add:
    "permission.utilities.officeconfiguration.officebrand.add",
  permission_utilities_officeconfiguration_officestatus_add:
    "permission.utilities.officeconfiguration.officestatus.add",
  permission_utilities_officeconfiguration_officetype_add:
    "permission.utilities.officeconfiguration.officetype.add",
  permission_utilities_officeconfiguration_channel_add:
    "permission.utilities.officeconfiguration.channel.add",
  permission_utilities_officeconfiguration_salestype_add:
    "permission.utilities.officeconfiguration.salestype.add",
  permission_utilities_officeconfiguration_officeorigin_add:
    "permission.utilities.officeconfiguration.officeorigin.add",
  permission_utilities_officeconfiguration_officestatusdetails_add:
    "permission.utilities.officeconfiguration.officestatusdetails.add",
  permission_utilities_officeconfiguration_officedivision_add:
    "permission.utilities.officedivision.add",

  // Office Config Texas grouping
  permission_utilities_officeconfiguration_texasgrouping_view:
    "permission.utilities.officeconfiguration.texasgrouping.view",
  permission_utilities_officeconfiguration_texasgrouping_add:
    "permission.utilities.officeconfiguration.texasgrouping.add",
  permission_utilities_officeconfiguration_texasgrouping_edit:
    "permission.utilities.officeconfiguration.texasgrouping.edit",
  permission_utilities_officeconfiguration_texasgrouping_delete:
    "permission.utilities.officeconfiguration.texasgrouping.delete",

  //Office Config Utility Delete
  permission_utilities_officeconfiguration_delete:
    "permission.utilities.officeconfiguration.delete",
  permission_utilities_officeconfiguration_glentity_delete:
    "permission.utilities.officeconfiguration.glentity.delete",
  permission_utilities_officeconfiguration_officebrand_delete:
    "permission.utilities.officeconfiguration.officebrand.delete",
  permission_utilities_officeconfiguration_officestatus_delete:
    "permission.utilities.officeconfiguration.officestatus.delete",
  permission_utilities_officeconfiguration_officetype_delete:
    "permission.utilities.officeconfiguration.officetype.delete",
  permission_utilities_officeconfiguration_channel_delete:
    "permission.utilities.officeconfiguration.channel.delete",
  permission_utilities_officeconfiguration_salestype_delete:
    "permission.utilities.officeconfiguration.salestype.delete",
  permission_utilities_officeconfiguration_officeorigin_delete:
    "permission.utilities.officeconfiguration.officeorigin.delete",
  permission_utilities_officeconfiguration_officestatusdetails_delete:
    "permission.utilities.officeconfiguration.officestatusdetails.delete",
  permission_utilities_officeconfiguration_officedivision_delete:
    "permission.utilities.officedivision.delete",

  // Office Config Office Department
  permission_utilities_officeconfiguration_officedepartment_view:
    "permission.utilities.officeconfiguration.officedepartment.view",
  permission_utilities_officeconfiguration_officedepartment_add:
    "permission.utilities.officeconfiguration.officedepartment.add",
  permission_utilities_officeconfiguration_officedepartment_edit:
    "permission.utilities.officeconfiguration.officedepartment.edit",
  permission_utilities_officeconfiguration_officedepartment_delete:
    "permission.utilities.officeconfiguration.officedepartment.delete",

  // Office Config BMO
  permission_utilities_officeconfiguration_officebmo_view:
    "permission.utilities.officeconfiguration.officebmo.view",
  permission_utilities_officeconfiguration_officebmo_add:
    "permission.utilities.officeconfiguration.officebmo.add",
  permission_utilities_officeconfiguration_officebmo_edit:
    "permission.utilities.officeconfiguration.officebmo.edit",
  permission_utilities_officeconfiguration_officebmo_delete:
    "permission.utilities.officeconfiguration.officebmo.delete",

  // Office Bank
  permission_utilities_officeconfiguration_officebank_view:
    "permission.utilities.officeconfiguration.officebank.view",
  permission_utilities_officeconfiguration_OfficeBank_add:
    "permission.utilities.officeconfiguration.officebank.add",
  permission_utilities_officeconfiguration_OfficeBank_edit:
    "permission.utilities.officeconfiguration.officebank.edit",
  permission_utilities_officeconfiguration_OfficeBank_delete:
    "permission.utilities.officeconfiguration.officebank.delete",

  //Office Account
  permission_utilities_officeconfiguration_officeaccount_view:
    "permission.utilities.officeconfiguration.officeaccount.view",
  permission_utilities_officeconfiguration_officeaccount_add:
    "permission.utilities.officeconfiguration.officeaccount.add",
  permission_utilities_officeconfiguration_officeaccount_edit:
    "permission.utilities.officeconfiguration.officeaccount.edit",
  permission_utilities_officeconfiguration_officeaccount_delete:
    "permission.utilities.officeconfiguration.officeaccount.delete",

  //Role Setting'
  permission_utilities_rolesetting_view:
    "permission.utilities.rolesetting.view",
  permission_utilities_configuration_view:
    //Configuration
    "permission.utilities.configuration.view",
  //UserRoleManagement
  permission_utilities_userrolemanagement_view:
    "permission.utilities.userrolemanagement.view",
  permission_utilities_userrolemanagement_edit:
    "permission.utilities.userrolemanagement.edit",
  permission_utilities_userrolemanagement_management_view:
    "permission.utilities.userrolemanagement.management.view",
  permission_utilities_userrolemanagement_management_edit:
    "permission.utilities.userrolemanagement.management.edit",

  //Office Digital Assets
  permiission_office_digitalassets_view: "permission.office.digitalassets.view",
  permiission_office_digitalassets_add: "permission.office.digitalassets.add",
  permiission_office_digitalassets_edit: "permission.office.digitalassets.edit",
  permiission_office_digitalassets_delete:
    "permission.office.digitalassets.delete",
  //Utilities Digital Assets Online Directories
  permission_utilities_digitalassets_onlinedirectories_view:
    "permission.utilities.onlinedirectories.view",
  permission_utilities_digitalassets_onlinedirectories_add:
    "permission.utilities.onlinedirectories.add",
  permission_utilities_digitalassets_onlinedirectories_edit:
    "permission.utilities.onlinedirectories.edit",
  permission_utilities_digitalassets_onlinedirectories_delete:
    "permission.utilities.onlinedirectories.delete",

  //Employee Training and Licensing
  permission_employee_training_view: "permission.employee.training.view",
  permission_employee_training_edit: "permission.employee.training.edit",
  permission_employee_training_add: "permission.employee.training.add",
  //Employee Additional Details
  permission_employee_additionaldetails_view:
    "permission.employee.additionaldetails.view",
  permission_employee_additionaldetails_edit:
    "permission.employee.additionaldetails.edit",
  permission_employee_additionaldetails_add:
    "permission.employee.additionaldetails.add",
  //Employee Contact Details
  permission_employee_contactdetails_view:
    "permission.employee.contactdetails.view",
  permission_employee_contactdetails_edit:
    "permission.employee.contactdetails.edit",
  permission_employee_contactdetails_add:
    "permission.employee.contactdetails.add",
  //Employee Associated Office Address
  permission_employee_associatedOffice_view:
    "permission.employee.associatedoffice.view",
  //Scorecard Module
  permission_scorecard_view: "permission.scorecard.view",
  permission_scorecard_add: "permission.scorecard.add",
  permission_scorecard_edit: "permission.scorecard.edit",
  permission_scorecard_delete: "permission.scorecard.delete",
  //Leased Equpment Module
  permission_leasedequipment_view: "permission.leasedequipment.view",
  permission_leasedequipment_add: "permission.leasedequipment.add",
  permission_leasedequipment_edit: "permission.leasedequipment.edit",
  permission_leasedequipment_delete: "permission.leasedequipment.delete",
  //Leased Equipment Reports
  permission_leasedequipment_reports_view:
    "permission.report.leasedequipment.view",
  //Agreement Reports
  permission_agreement_reports_view: "permission.report.agreement.view",
  // Business Licenses and Permits
  permission_buslicensesandpermits_view:
    "permission.buslicensesandpermits.view",
  permission_buslicensesandpermits_add: "permission.buslicensesandpermits.add",
  permission_buslicensesandpermits_edit:
    "permission.buslicensesandpermits.edit",
  permission_buslicensesandpermits_delete:
    "permission.buslicensesandpermits.delete",
  //Business Licenses and Permits Reports
  permission_report_businesslicensepermit_businesslicensespermitreports_view:
    "permission.report.businesslicensepermit.businesslicensespermitreports.view",
  permission_report_businesslicensepermit_businesslicensespermitreportsall_view:
    "permission.report.businesslicensepermit.businesslicensespermitreportsall.view",
  permission_report_businesslicensepermit_businesslicensespermitreportswestbu_view:
    "permission.report.businesslicensepermit.businesslicensespermitreportswestbu.view",

  //Security Module
  permission_security_view: "permission.security.view",
  permission_security_add: "permission.security.add",
  permission_security_edit: "permission.security.edit",
  permission_security_delete: "permission.security.delete",

  //Vendor Module
  permission_vendor_view: "permission.vendor.view",
  permission_vendor_add: "permission.vendor.add",
  permission_vendor_edit: "permission.vendor.edit",
  permission_vendor_delete: "permission.vendor.delete",

  //Vendor Security
  permission_vendor_vendorSecurity_view:
    "permission.vendor.vendorsecurity.view",
  permission_vendor_vendorSecurity_edit:
    "permission.vendor.vendorsecurity.edit",
  permission_vendor_vendorSecurity_add: "permission.vendor.vendorsecurity.add",

  //Vendor Invoice Module
  permission_vendorinvoice_view: "permission.vendorinvoice.view",
  permission_vendorinvoice_add: "permission.vendorinvoice.add",
  permission_vendorinvoice_edit: "permission.vendorinvoice.edit",
  permission_vendorinvoice_delete: "permission.vendorinvoice.delete",

  //Vendor Office Module
  permission_vendor_office_view: "permission.vendor.office.view",
  permission_vendor_office_add: "permission.vendor.office.add",
  permission_vendor_office_edit: "permission.vendor.office.edit",
  permission_vendor_office_delete: "permission.vendor.office.delete",

  //Utilities Security Config View
  permission_utilities_securityconfiguration_view:
    "permission.utilities.securityconfiguration.view",

  //Utilities Data Connection
  permission_utilities_securityconfiguration_dataconnection_view:
    "permission.utilities.securityconfiguration.dataconnection.view",
  permission_utilities_securityconfiguration_dataconnection_add:
    "permission.utilities.securityconfiguration.dataconnection.add",
  permission_utilities_securityconfiguration_dataconnection_edit:
    "permission.utilities.securityconfiguration.dataconnection.edit",
  permission_utilities_securityconfiguration_dataconnection_delete:
    "permission.utilities.securityconfiguration.dataconnection.delete",

  //Utilities Alarm Type
  permission_utilities_securityconfiguration_alarmtype_view:
    "permission.utilities.securityconfiguration.alarmtype.view",
  permission_utilities_securityconfiguration_alarmtype_add:
    "permission.utilities.securityconfiguration.alarmtype.add",
  permission_utilities_securityconfiguration_alarmtype_edit:
    "permission.utilities.securityconfiguration.alarmtype.edit",
  permission_utilities_securityconfiguration_alarmtype_delete:
    "permission.utilities.securityconfiguration.alarmtype.delete",

  //Utilities DVR Type
  permission_utilities_securityconfiguration_dvrtype_view:
    "permission.utilities.securityconfiguration.dvrtype.view",
  permission_utilities_securityconfiguration_dvrtype_add:
    "permission.utilities.securityconfiguration.dvrtype.add",
  permission_utilities_securityconfiguration_dvrtype_edit:
    "permission.utilities.securityconfiguration.dvrtype.edit",
  permission_utilities_securityconfiguration_dvrtype_delete:
    "permission.utilities.securityconfiguration.dvrtype.delete",

  //Utilities Camera System
  permission_utilities_securityconfiguration_camerasystem_view:
    "permission.utilities.securityconfiguration.camerasystem.view",
  permission_utilities_securityconfiguration_camerasystem_add:
    "permission.utilities.securityconfiguration.camerasystem.add",
  permission_utilities_securityconfiguration_camerasystem_edit:
    "permission.utilities.securityconfiguration.camerasystem.edit",
  permission_utilities_securityconfiguration_camerasystem_delete:
    "permission.utilities.securityconfiguration.camerasystem.delete",

  //Utilities File Category
  permission_utilities_securityconfiguration_filecategory_view:
    "permission.utilities.securityconfiguration.filecategory.view",
  permission_utilities_securityconfiguration_filecategory_add:
    "permission.utilities.securityconfiguration.filecategory.add",
  permission_utilities_securityconfiguration_filecategory_edit:
    "permission.utilities.securityconfiguration.filecategory.edit",
  permission_utilities_securityconfiguration_filecategory_delete:
    "permission.utilities.securityconfiguration.filecategory.delete",

  //Utilities Warranty Coverage
  permission_utilities_securityconfiguration_warrantycoverage_view:
    "permission.utilities.securityconfiguration.warrantycoverage.view",
  permission_utilities_securityconfiguration_warrantycoverage_add:
    "permission.utilities.securityconfiguration.warrantycoverage.add",
  permission_utilities_securityconfiguration_warrantycoverage_edit:
    "permission.utilities.securityconfiguration.warrantycoverage.edit",
  permission_utilities_securityconfiguration_warrantycoverage_delete:
    "permission.utilities.securityconfiguration.warrantycoverage.delete",

  //Utilities Safe Type
  permission_utilities_securityconfiguration_safetype_view:
    "permission.utilities.securityconfiguration.safetype.view",
  permission_utilities_securityconfiguration_safetype_add:
    "permission.utilities.securityconfiguration.safetype.add",
  permission_utilities_securityconfiguration_safetype_edit:
    "permission.utilities.securityconfiguration.safetype.edit",
  permission_utilities_securityconfiguration_safetype_delete:
    "permission.utilities.securityconfiguration.safetype.delete",

  //Utilites Safe Make
  permission_utilities_securityconfiguration_safemake_view:
    "permission.utilities.securityconfiguration.safemake.view",
  permission_utilities_securityconfiguration_safemake_add:
    "permission.utilities.securityconfiguration.safemake.add",
  permission_utilities_securityconfiguration_safemake_edit:
    "permission.utilities.securityconfiguration.safemake.edit",
  permission_utilities_securityconfiguration_safemake_delete:
    "permission.utilities.securityconfiguration.safemake.delete",

  //Utilities Camera Type 1
  permission_utilities_securityconfiguration_cameratype1_view:
    "permission.utilities.securityconfiguration.cameratype1.view",
  permission_utilities_securityconfiguration_cameratype1_add:
    "permission.utilities.securityconfiguration.cameratype1.add",
  permission_utilities_securityconfiguration_cameratype1_edit:
    "permission.utilities.securityconfiguration.cameratype1.edit",
  permission_utilities_securityconfiguration_cameratype1_delete:
    "permission.utilities.securityconfiguration.cameratype1.delete",

  //Utilities Camera Type 2
  permission_utilities_securityconfiguration_cameratype2_view:
    "permission.utilities.securityconfiguration.cameratype2.view",
  permission_utilities_securityconfiguration_cameratype2_add:
    "permission.utilities.securityconfiguration.cameratype2.add",
  permission_utilities_securityconfiguration_cameratype2_edit:
    "permission.utilities.securityconfiguration.cameratype2.edit",
  permission_utilities_securityconfiguration_cameratype2_delete:
    "permission.utilities.securityconfiguration.cameratype2.delete",

  //EmployeeBilingual
  permission_utilities_employeebilingual_view:
    "permission.utilities.employeebilingual.view",
  permission_utilities_employeebilingual_add:
    "permission.utilities.employeebilingual.add",
  permission_utilities_employeebilingual_edit:
    "permission.utilities.employeebilingual.edit",
  permission_utilities_employeebilingual_delete:
    "permission.utilities.employeebilingual.delete",

  // Employee Ad Override Group
  permission_utilities_employeeadoverridegroup_view:
    "permission.utilities.employeeadoverridegroup.view",
  permission_utilities_employeeadoverridegroup_add:
    "permission.utilities.employeeadoverridegroup.add",
  permission_utilities_employeeadoverridegroup_edit:
    "permission.utilities.employeeadoverridegroup.edit",
  permission_utilities_employeeadoverridegroup_delete:
    "permission.utilities.employeeadoverridegroup.delete",

  //Operations Group Configuration
  permission_utilities_operationsgroup_add:
    "permission.utilities.operationsgroup.add",
  permission_utilities_operationsgroup_edit:
    "permission.utilities.operationsgroup.edit",
  permission_utilities_operationsgroup_delete:
    "permission.utilities.operationsgroup.delete",
  permission_utilities_operationsgroup_view:
    "permission.utilities.operationsgroup.view",

  //JobConfiguration
  permission_utilities_jobconfiguration_view:
    "permission.utilities.jobconfiguration.view",
  permission_utilities_jobconfiguration_add:
    "permission.utilities.jobconfiguration.add",
  permission_utilities_jobconfiguration_edit:
    "permission.utilities.jobconfiguration.edit",
  permission_utilities_jobconfiguration_delete:
    "permission.utilities.jobconfiguration.delete",

  //BLP Type
  permission_utilities_businesslicensespermitsconfiguration_type_view:
    "permission.utilities.businesslicenses&permitsconfiguration.type.view",
  permission_utilities_businesslicensespermitsconfiguration_type_add:
    "permission.utilities.businesslicenses&permitsconfiguration.type.add",
  permission_utilities_businesslicensespermitsconfiguration_type_edit:
    "permission.utilities.businesslicenses&permitsconfiguration.type.edit",
  permission_utilities_businesslicensespermitsconfiguration_type_delete:
    "permission.utilities.businesslicenses&permitsconfiguration.type.delete",

  //Script Configuration
  permission_utilities_scriptconfiguration_view:
    "permission.utilities.scriptconfiguration.view",
  permission_utilities_scriptconfiguration_edit:
    "permission.utilities.scriptconfiguration.edit",

  //Custom Report
  permission_utilities_customreport_view:
    "permission.utilities.customreport.view",
  permission_utilities_customreport_add:
    "permission.utilities.customreport.add",
  permission_utilities_customreport_edit:
    "permission.utilities.customreport.edit",
  permission_utilities_customreport_delete:
    "permission.utilities.customreport.delete",

  //Vendor Configuration
  permission_utilities_vendorconfiguration_view:
    "permission.utilities.vendorconfiguration.view",
  permission_utilities_expenseaccount_view:
    "permission.utilities.vendorconfiguration.expenseaccount.view",
  permission_utilities_expenseaccount_add:
    "permission.utilities.vendorconfiguration.expenseaccount.add",
  permission_utilities_expenseaccount_delete:
    "permission.utilities.vendorconfiguration.expenseaccount.delete",
  permission_utilities_expenseaccount_edit:
    "permission.utilities.vendorconfiguration.expenseaccount.edit",
  permission_utilities_autopay_view:
    "permission.utilities.vendorconfiguration.autopay.view",
  permission_utilities_autopay_add:
    "permission.utilities.vendorconfiguration.autopay.add",
  permission_utilities_autopay_delete:
    "permission.utilities.vendorconfiguration.autopay.delete",
  permission_utilities_autopay_edit:
    "permission.utilities.vendorconfiguration.autopay.edit",

  //Acquisition Configuration
  permission_utilities_acquisitionconfiguration_view:
    "permission.utilities.acquisitionconfiguration.view",
  permission_utilities_acquisitionconfiguration_add:
    "permission.utilities.acquisitionconfiguration.add",
  permission_utilities_acquisitionconfiguration_edit:
    "permission.utilities.acquisitionconfiguration.edit",
  permission_utilities_acquisitionconfiguration_delete:
    "permission.utilities.acquisitionconfiguration.delete",

  //Home Company Configuration
  permission_utilities_homecompany_type_view:
    "permission.utilities.homecompany.view",
  permission_utilities_homecompany_type_add:
    "permission.utilities.homecompany.add",
  permission_utilities_homecompany_type_edit:
    "permission.utilities.homecompany.edit",
  permission_utilities_homecompany_type_delete:
    "permission.utilities.homecompany.delete",

  //Hierarchy
  permission_hierarchy_view: "permission.hierarchy.view",
  permission_hierarchy_add: "permission.hierarchy.add",
  permission_hierarchy_update: "permission.hierarchy.edit",
  permission_hierarchy_delete: "permission.hierarchy.delete",

  // #region Office Appliances
  permission_utilities_officeappliances_view:
    "permission.utilities.officeappliances.view",
  permission_utilities_officeappliances_type_view:
    "permission.utilities.officeappliances.type.view",
  permission_utilities_officeappliances_type_add:
    "permission.utilities.officeappliances.type.add",
  permission_utilities_officeappliances_type_edit:
    "permission.utilities.officeappliances.type.edit",
  permission_utilities_officeappliances_type_delete:
    "permission.utilities.officeappliances.type.delete",
  // #endregion Office Appliances

  permission_officeappliancebrand_view:
    "permission.utilities.officeappliances.brand.view",
  permission_officeappliancebrand_add:
    "permission.utilities.officeappliances.brand.add",
  permission_officeappliancebrand_edit:
    "permission.utilities.officeappliances.brand.edit",
  permission_officeappliancebrand_delete:
    "permission.utilities.officeappliances.brand.delete",
};
export const FIELDPERMISSIONS = {
  //Producer Code Field Access
  fieldpermission_producercode_mappedtocdrc:
    "fieldpermission.producercode_mappedtocdrc",
  fieldpermission_producercode_mappedtokeeper:
    "fieldpermission.producercode_mappedtokeeper",
  //Employee Field Access
  fieldpermission_employee_updateapproved:
    "fieldpermission.employee.updateapproved",
  fieldpermission_employee_updateapprovedReadOnly:
    "fieldpermission.employee.updateapprovedreadonly",
  //Office Hierarchy Field Access
  fieldpermission_officehierarchy_contact:
    "fieldpermission.officehierarchy.contact",
  fieldpermission_officehierarchy_isfranchise:
    "fieldpermission.officehierarchy.isfranchise",
  //Vendor Field
  fieldpermission_vendor_user: "fieldpermission.vendor.user",
  fieldpermission_vendor_sensitive: "fieldpermission.vendor.sensitive",
  fieldpermission_vendor_securitypersonnel:
    "fieldpermission.vendor.securitypersonnel",
  //Vendor Invoice
  fieldpermission_vendorinvoice_approver:
    "fieldpermission.vendorinvoice.apapprover",
  fieldpermission_vendorinvoice_analyst:
    "fieldpermission.vendorinvoice.apanalyst",

  //Main tabs
  fieldpermission_maintab_carriertab: "fieldpermission.maintab.carriertab",
  fieldpermission_maintab_officetab: "fieldpermission.maintab.officetab",
  fieldpermission_maintab_employeetab: "fieldpermission.maintab.employeetab",
  fieldpermission_maintab_vendortab: "fieldpermission.maintab.vendortab",
  fieldpermission_maintab_reportstab: "fieldpermission.maintab.reportstab",
  fieldpermission_maintab_utilitiestab: "fieldpermission.maintab.utilitiestab",

  //Carrier
  fieldpermission_carrier_metricsperstate:
    "fieldpermission.carrier.carriermetricperstate.view",

  //Acquisition Name
  fieldpermission_employee_acquisitionname:
    "fieldpermission.employee.acquisitionname",

  //Vendor Configuration
  fieldpermission_utilities_vendorconfiguration:
    "fieldpermission.utilities.vendorConfiguration",

  //TJ HR Users
  fieldpermission_employee_separationtype:
    "fieldpermission.employee.separationtype",
  fieldpermission_employee_separationreason:
    "fieldpermission.employee.separationreason",
  fieldpermission_employee_rehirable: "fieldpermission.employee.rehirable",

  //Digital Assets
  fieldpermission_office_digitalassets_facebook:
    "fieldpermission.office.facebook",
  fieldpermission_office_digitalassets_directorygeneraldescription:
    "fieldpermission.office.directorygeneraldescription",
  fieldpermission_office_digitalassets_yelpprofileurl:
    "fieldpermission.office.yelpprofileurl",
  fieldpermission_office_digitalassets_yelpdescription:
    "fieldpermission.office.yelpdescription",
  fieldpermission_office_digitalassets_googlebusinessurl:
    "fieldpermission.office.googlebusinessurl",
  fieldpermission_office_digitalassets_googledescription:
    "fieldpermission.office.googledescription",
  fieldpermission_office_digitalassets_twitterurl:
    "fieldpermission.office.twitterurl",
  fieldpermission_office_digitalassets_linkedinurl:
    "fieldpermission.office.linkedinurl",
  fieldpermission_office_digitalassets_youtubeurl:
    "fieldpermission.office.youtubeurl",
  fieldpermission_office_digitalassets_instagramurl:
    "fieldpermission.office.instagramurl",
};
